import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from 'components/Grid';

const Row = styled('div')`
  display: flex;
  align-items: center;
  min-height: 30px;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding: 0.1rem 0.25rem 0.1rem 0.75rem;
  ${({ darker }) => darker && 'border-top: 1px solid rgba(0, 0, 0, 0.12)'};
`;

const PostFooterBar = ({ darker, actions, children, ...rest }) => {
  const isSmallScreen = useMediaQuery('(max-width: 359px');

  const spacing = isSmallScreen ? 0 : 1;

  return (
    <Row darker={darker} {...rest}>
      <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap" spacing={spacing}>
        <Grid item>
          <Grid container alignItems="center" wrap="nowrap" spacing={spacing}>
            {children}
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" wrap="nowrap" spacing={spacing}>
            {actions}
          </Grid>
        </Grid>
      </Grid>
    </Row>
  );
};

PostFooterBar.propTypes = {
  darker: PropTypes.bool,
  actions: PropTypes.node,
};

export default PostFooterBar;
